(() => {
  const money=(c,curr)=>{try{return new Intl.NumberFormat('fr-FR',{style:'currency',currency:curr||'EUR'}).format((Number(c)||0)/100)}catch(_){return((Number(c)||0)/100).toFixed(2).replace('.',',')+' €'}};
  const esc=s=>String(s??'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const vars=p=>(p?.variants||[]).filter(v=>v.available!==false);
  const vals=v=>Array.isArray(v?.options)&&v.options.length?v.options.map(String):[v?.option1,v?.option2,v?.option3].filter(x=>x!==null&&x!==undefined).map(String);
  const names=p=>(Array.isArray(p?.options)?p.options:[]).map((o,i)=>typeof o==='string'?o:(o?.name||o?.title||('Option '+(i+1))));
  const imageOf=(v,p)=>{const f=v?.featured_image;if(typeof f==='string')return f;if(f?.src)return f.src;if(f?.url)return f.url;return p?.featured_image||p?.images?.[0]||''};

  async function getCart(){try{const r=await fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});return r.ok?await r.json():null}catch(_){return null}}
  async function fullProduct(handle){try{const r=await fetch('/products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'},cache:'no-store'});return r.ok?await r.json():null}catch(_){return null}}

  function renderProgress(root,c){
    if(root.dataset.context==='product')return;
    const subtotal=Number(c?.total_price??root.dataset.subtotal??0), relay=5000, express=13000, curr=root.dataset.currency||c?.currency||'EUR';
    const title=root.querySelector('[data-laf-shipping-title]'), copy=root.querySelector('[data-laf-shipping-copy]'), fill=root.querySelector('[data-laf-shipping-fill]');
    if(fill)fill.style.width=Math.max(0,Math.min(100,subtotal/express*100))+'%';
    if(subtotal<relay){
      title.textContent='Plus que '+money(relay-subtotal,curr)+' pour le Point Relais offert';
      copy.textContent='Puis offres privées dès 80 € · Express offerte dès 130 €';
    } else if(subtotal<8000){
      title.textContent='POINT RELAIS OFFERT ✓';
      copy.textContent='Encore '+money(8000-subtotal,curr)+' pour débloquer votre première offre privée à -10 % · Express dès 130 €';
    } else if(subtotal<express){
      title.textContent='OFFRE PRIVÉE DÉBLOQUÉE ✓';
      copy.textContent='-10 % sur 1 article complémentaire · encore '+money(express-subtotal,curr)+' pour l’Express offerte';
    } else {
      title.textContent='LIVRAISON EXPRESS OFFERTE ✓';
      copy.textContent='Meilleur niveau atteint · jusqu’à 2 articles complémentaires à -10 %';
    }
  }

  function optionUi(p){
    const available=vars(p), optionNames=names(p);
    if(available.length<=1||!optionNames.length)return'';
    return '<div class="laf-ship-rec__options">'+optionNames.map((name,i)=>{
      const distinct=[...new Set(available.map(v=>vals(v)[i]).filter(Boolean))];
      if(distinct.length<=1)return'';
      return '<label class="laf-ship-rec__option"><span>'+esc(name)+'</span><select data-laf-ship-option="'+i+'"><option value="">Choisir</option>'+distinct.map(v=>'<option value="'+esc(v)+'">'+esc(v)+'</option>').join('')+'</select></label>';
    }).join('')+'</div><small class="laf-ship-rec__hint">Choisissez vos options avant l’ajout.</small>';
  }

  function isSelectable(p){
    const available=vars(p), optionNames=names(p);
    return available.length>1 && optionNames.some((_,i)=>new Set(available.map(v=>vals(v)[i]).filter(Boolean)).size>1);
  }

  function card(p,pref,curr){
    const needsChoice=isSelectable(p), img=imageOf(pref,p);
    return '<article class="laf-ship-rec" data-laf-ship-product="'+p.id+'">'+
      (img?'<img data-laf-ship-image src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy">':'')+
      '<div class="laf-ship-rec__content"><p class="laf-ship-rec__title">'+esc(p.title)+'</p>'+
      '<span class="laf-ship-rec__price" data-laf-ship-price>'+money(pref.price,curr)+'</span>'+
      optionUi(p)+
      '<button type="button" data-laf-ship-add="'+(needsChoice?'':pref.id)+'" '+(needsChoice?'disabled':'')+'>'+(needsChoice?'CHOISIR LES OPTIONS':'AJOUTER +')+'</button></div></article>';
  }

  function selected(card,count){const a=Array(count).fill('');card.querySelectorAll('[data-laf-ship-option]').forEach(s=>a[Number(s.dataset.lafShipOption)]=s.value);return a}
  function match(p,selection){
    if(selection.some(v=>!v))return null;
    return vars(p).find(v=>{const a=vals(v);return selection.every((x,i)=>String(a[i])===String(x))})||null;
  }
  function sync(root,select){
    const card=select.closest('[data-laf-ship-product]'); if(!card)return;
    const p=root._lafProducts?.get(String(card.dataset.lafShipProduct)); if(!p)return;
    const choice=selected(card,names(p).length), variant=match(p,choice), button=card.querySelector('[data-laf-ship-add]');
    if(!variant){
      if(button){button.dataset.lafShipAdd='';button.disabled=true;button.textContent=choice.some(v=>!v)?'CHOISIR LES OPTIONS':'INDISPONIBLE'}
      return;
    }
    const price=card.querySelector('[data-laf-ship-price]'); if(price)price.textContent=money(variant.price,root.dataset.currency||'EUR');
    const img=card.querySelector('[data-laf-ship-image]'), next=imageOf(variant,p); if(img&&next)img.src=next;
    if(button){button.dataset.lafShipAdd=String(variant.id);button.disabled=false;button.textContent='AJOUTER +'}
  }

  async function recommendations(root,c){
    const box=root.querySelector('[data-laf-shipping-recs]'),grid=root.querySelector('[data-laf-shipping-recs-grid]'),copy=root.querySelector('[data-laf-shipping-recs-copy]');
    if(!box||!grid||!c?.items?.length)return;
    const subtotal=Number(c.total_price||0),target=subtotal<5000?5000:subtotal<8000?8000:0;
    if(!target){box.hidden=true;return}
    const gap=target-subtotal;
    const anchor=c.items[c.items.length-1]?.product_id; if(!anchor){box.hidden=true;return}
    try{
      const r=await fetch('/recommendations/products.json?product_id='+encodeURIComponent(anchor)+'&limit=10&intent=related');
      if(!r.ok)throw 0;
      const j=await r.json(),inCart=new Set(c.items.map(i=>String(i.product_id)));
      const brief=(j.products||[]).filter(p=>p?.handle&&!inCart.has(String(p.id))).slice(0,6);
      const full=(await Promise.all(brief.map(p=>fullProduct(p.handle)))).filter(p=>p&&p.available!==false&&vars(p).length);
      const ranked=full.map(p=>{const pref=[...vars(p)].sort((a,b)=>Math.abs(Number(a.price)-gap)-Math.abs(Number(b.price)-gap))[0];return{p,pref,d:Math.abs(Number(pref.price)-gap)}}).sort((a,b)=>a.d-b.d).slice(0,2);
      if(!ranked.length){box.hidden=true;return}
      root._lafProducts=new Map(ranked.map(({p})=>[String(p.id),p]));
      copy.textContent='Objectif '+money(target,root.dataset.currency||'EUR');
      grid.innerHTML=ranked.map(({p,pref})=>card(p,pref,root.dataset.currency||'EUR')).join('');
      box.hidden=false;
    }catch(_){box.hidden=true}
  }

  async function refresh(root){const c=await getCart();if(!c)return;renderProgress(root,c);await recommendations(root,c)}
  function bind(root){
    if(root.dataset.lafBound)return;root.dataset.lafBound='1';
    root.addEventListener('change',e=>{const s=e.target.closest('[data-laf-ship-option]');if(s&&root.contains(s))sync(root,s)});
    root.addEventListener('click',async e=>{
      const b=e.target.closest('[data-laf-ship-add]');if(!b||!root.contains(b)||b.disabled)return;
      const id=Number(b.dataset.lafShipAdd||0);if(!id)return;
      b.disabled=true;b.textContent='AJOUT…';
      try{
        const r=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if(!r.ok)throw 0;
        document.dispatchEvent(new CustomEvent('laf:cart-changed'));setTimeout(()=>location.reload(),250);
      }catch(_){b.disabled=false;b.textContent='RÉESSAYER'}
    });
    refresh(root);
  }
  const boot=()=>document.querySelectorAll('[data-laf-shipping]').forEach(bind);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('laf:cart-changed',()=>document.querySelectorAll('[data-laf-shipping]').forEach(refresh));
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate)subscribe(PUB_SUB_EVENTS.cartUpdate,()=>setTimeout(()=>document.querySelectorAll('[data-laf-shipping]').forEach(refresh),30));
})();